import { Input, Pagination } from 'antd';
import { PaginationProps } from 'antd/lib/pagination';
import PublicHolidaysHeader from 'components/common/tables_header/public_holidays_header';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import { month, mrs1, period, monthName } from 'utils';
type publicHolidaysProps = {
  addData?: (data: any) => void;
  setCheckLength?: (data: boolean) => void;
  finalData?: any;
  data?: any;
  checkLength?: boolean;
};

const PublicHolidays = ({ addData, finalData, data, checkLength, setCheckLength }: publicHolidaysProps) => {
  const [state, setState] = useState({
    public_holidays: {
      day: 1,
      month: 1,
      period: 'all_day',
      gender: 'all',
      description: '',
    },
  });

  const { public_holidays } = state;
  const displayedItems = finalData?.public_holidays

  const formik = useFormik({
    initialValues: {
      day: 1,
      month: 1,
      period: '',
      gender: '',
      description: '',
    },
    onSubmit: (data) => {
      // addItems(data);
    },
  });

  const deleteItems = (id: number) => {

    const t = finalData.public_holidays.filter((o: any, i: number) => i !== id);
    if (t.length <= 1) {
      setCheckLength(false);
    } else {
      setCheckLength(true)
    }
    addData(Object.assign(finalData, { public_holidays: t }));
  };

  const addItems = () => {
    addData({
      public_holidays: [...finalData.public_holidays, public_holidays],
    });
    setCheckLength(true);
    formik.resetForm();
  };

  return (
    <div style={{ marginTop: '50px' }}>
      <section className={'function_container'}>
        <div
          style={{ background: 'white', padding: 0, paddingBottom: 100 }}
          className={'function_wrapper'}
        >
          <div
            style={{
              display: 'flex',
              gap: '10px',
              borderBottom: '0.5px solid #73A1E7',
            }}
          >
            <div
              style={{
                // borderBottom: '0.5px solid #73A1E7',
                padding: '15px 25px 15px 25px',
                fontWeight: 500,
                fontSize: 20,
                color: '#000000',
              }}
            >
              Public Holidays
            </div>

          </div>

          <PublicHolidaysHeader />
          <div>
            {displayedItems?.length === 0 ? (
              <div style={{ display: 'flex', padding: 10 }}>

                <div
                  style={{
                    marginLeft: '45%',
                    color: '#D1D1D1',
                  }}
                >
                  <div
                    style={{ color: '#000000', fontWeight: 400, fontSize: 12 }}
                  >
                    No item
                  </div>
                </div>
              </div>
            ) : (
              displayedItems?.map((x, index: number) => (
                <div key={index}>
                  <div
                    style={{
                      display: 'flex',
                      width: '100%',
                      gap: 8,
                      padding: 8,
                    }}
                  >
                    <div
                      style={{ width: '12.7%', background: data && '#f5f5f5' }}
                    >
                      <select
                        disabled={data}
                        onChange={(e) => {
                          const t = finalData.public_holidays.map(
                            (o: any, p: number) => {
                              if (p === index) {
                                return {
                                  ...o,
                                  month: e.target.value,
                                  day: 1,
                                };
                              } else {
                                return {
                                  ...o,
                                };
                              }
                            },
                          );
                          addData(
                            Object.assign(finalData, { public_holidays: t }),
                          );
                        }}
                        defaultValue={x.month}
                        value={x.month}
                        style={{
                          width: '100%',
                          height: 30,
                          border: '0.5px solid #407FDD',
                          padding: '0px 0px 0px 5px',
                          pointerEvents: data ? 'none' : 'auto'
                        }}
                        className="common_custom_input_search"

                      >
                        {month.map((item, index) => (
                          <option style={{ fontFamily: 'IBM Plex Serif' }} key={index} value={item.value}>
                            {item.label}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div
                      style={{ width: '12.7%', background: data && '#f5f5f5' }}
                    >
                      <select
                        disabled={data}
                        onChange={(e) => {
                          const t = finalData.public_holidays.map(
                            (o: any, p: number) => {
                              if (p === index) {
                                return {
                                  ...o,
                                  day: e.target.value,
                                };
                              } else {
                                return {
                                  ...o,
                                };
                              }
                            },
                          );
                          addData(
                            Object.assign(finalData, { public_holidays: t }),
                          );
                        }}
                        defaultValue={x.day}
                        value={x.day}
                        style={{
                          width: '100%',
                          height: 30,
                          border: '0.5px solid #407FDD',
                          padding: '0px 0px 0px 5px',
                          pointerEvents: data ? 'none' : 'auto'
                        }}
                        className="common_custom_input_search"

                      >
                        {Array.from({ length: monthName[x.month - 1].day }, (_, i) => (
                          <option style={{ fontFamily: 'IBM Plex Serif' }} key={i + 1} value={i + 1}>
                            {i + 1}
                          </option>
                        ))}
                      </select>
                    </div>
                    {/* <Input
                      min={0}
                      max={31}
                      onPaste={(e) => {
                        e.preventDefault();
                      }}
                      disabled={data}
                      defaultValue={x.day}
                      value={x.day}
                      onChange={(e) => {
                        const newValue = e.target.value;
                        const parsedValue = parseInt(newValue, 10);

                        if (parsedValue > 31) {
                          return;
                        }
                        const t = finalData.public_holidays.map(
                          (o: any, p: number) => {
                            if (p === index) {
                              return {
                                ...o,
                                day: e.target.value,
                              };
                            } else {
                              return {
                                ...o,
                              };
                            }
                          },
                        );
                        addData(
                          Object.assign(finalData, { public_holidays: t }),
                        );
                      }}
                      type="number"
                      onKeyDown={handleKeyDown}
                      style={{ width: '16%', height: '30px', background: data && '#f5f5f5' }}
                      className="common_custom_input_search"
                    /> */}

                    <div
                      style={{ width: '12.7%', background: data && '#f5f5f5' }}
                    >
                      <select
                        disabled={data}
                        onChange={(e) => {
                          const t = finalData.public_holidays.map(
                            (o: any, p: number) => {
                              if (p === index) {
                                return {
                                  ...o,
                                  period: e.target.value,
                                };
                              } else {
                                return {
                                  ...o,
                                };
                              }
                            },
                          );
                          addData(
                            Object.assign(finalData, { public_holidays: t }),
                          );
                        }}
                        defaultValue={x.period}
                        value={x.period}
                        style={{
                          width: '100%',
                          height: 30,
                          border: '0.5px solid #407FDD',
                          padding: '0px 0px 0px 5px',
                          pointerEvents: data ? 'none' : 'auto'
                        }}
                        className="common_custom_input_search"

                      >
                        {period.map((item, index) => (
                          <option style={{ fontFamily: 'IBM Plex Serif' }} key={index} value={item.value}>
                            {item.label}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div
                      style={{ width: '12.7%', background: data && '#f5f5f5' }}
                    >
                      <select
                        disabled={data}
                        onChange={(e) => {
                          const t = finalData.public_holidays.map(
                            (o: any, p: number) => {
                              if (p === index) {
                                return {
                                  ...o,
                                  gender: e.target.value,
                                };
                              } else {
                                return {
                                  ...o,
                                };
                              }
                            },
                          );
                          addData(
                            Object.assign(finalData, { public_holidays: t }),
                          );
                        }}
                        defaultValue={x.gender}
                        value={x.gender}
                        style={{
                          width: '100%',
                          height: 30,
                          border: '0.5px solid #407FDD',
                          padding: '0px 0px 0px 5px',
                          pointerEvents: data ? 'none' : 'auto'
                        }}
                        className="common_custom_input_search"
                      >
                        {mrs1.map((item, index) => (
                          <option style={{ fontFamily: 'IBM Plex Serif' }} key={index} value={item.value}>
                            {item.label}
                          </option>
                        ))}
                      </select>
                    </div>
                    <input
                      disabled={data}
                      onChange={(e) => {
                        const t = finalData.public_holidays.map(
                          (o: any, p: number) => {
                            if (p === index) {
                              return {
                                ...o,
                                description: e.target.value,
                              };
                            } else {
                              return {
                                ...o,
                              };
                            }
                          },
                        );
                        addData(
                          Object.assign(finalData, { public_holidays: t }),
                        );
                      }}
                      defaultValue={x.description}
                      value={x.description}
                      style={{
                        width: '12.7%', height: '30px', background: data && '#f5f5f5',
                        border: data ? 'none' : '0.5px solid #407FDD',
                        cursor: data ? 'not-allowed' : '', pointerEvents: data ? 'none' : 'auto',
                        padding: '0px 0px 0px 5px',
                      }}
                      maxLength={150}
                      className="common_custom_input_search"
                    />
                    <div
                      style={{
                        display: 'flex',
                        padding: 5,
                        width: '40%',
                      }}
                    >
                      {!data && (
                        <div style={{ display: 'flex', gap: 24, marginLeft: '75%' }}>
                          <button
                            type="submit"
                            style={{ background: 'white', border: 'none' }}
                          >
                            <img
                              style={{ cursor: 'pointer', height: '22px', width: '22px' }}
                              onClick={() => {
                                addItems();
                              }}
                              src="/icons/carbon_add-filled.svg"
                              alt="add"
                            />
                          </button>
                          {checkLength && (<button
                            style={{ background: 'white', border: 'none' }}
                          >
                            <img
                              onClick={() => {
                                deleteItems(index)
                              }}
                              style={{ cursor: 'pointer', height: '22px', width: '22px' }}
                              src="/icons/carbon_close-filled.svg"
                              alt="delete"
                            />
                          </button>)}
                        </div>

                      )}
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>

      </section>
    </div>
  );
};

export default PublicHolidays;
